import axios from 'axios';

axios.defaults.headers.common['X-CSRF-TOKEN'] = document.cookie.split("=")[1];

//const baseUrl = 'http://localhost:4810/Api';

export default {




    //********************************************************************| Authintecations |***********************************************************

    login(bodyObjeect) {
        return axios.post(`/Security/login`, bodyObjeect);
    },

    IsLoggedin() { 
        return axios.get(`/Security/IsLoggedin`);
    },

    Logout() {
        return axios.post(`/Security/Logout`);
    },





    //// ********************************| Products |********************************


    GetProducts(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Products/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllProducts() {
        return axios.get(`api/admin/Products/GetAll`);
    },

    AddProducts(bodyObject) {
        return axios.post(`api/admin/Products/Add`, bodyObject);
    },

    EditProducts(bodyObject) {
        return axios.post(`api/admin/Products/Edit`, bodyObject);
    },

    ChangeStatusProducts(Id) {
        return axios.post(`api/admin/Products/${Id}/ChangeStatus`);
    },

    DeleteProducts(Id) {
        return axios.post(`api/admin/Products/${Id}/Delete`);
    },



    //ProductsCounts

    GetAllProductsCounts() {
        return axios.get(`api/admin/Products/Counts/GetAll`);
    },

    GetProductsCounts(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Products/Counts/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    //// ********************************| End Of Products |********************************





    //// ********************************| Financial |********************************

    GetFinancial(pageNo, pageSize, Search, ByCustomersId, BySupplierId, ByPaymentsMethodsId, ByType) {
        return axios.get(`api/admin/Financial/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}
            &CustomersId=${ByCustomersId}&SupplierId=${BySupplierId}&PaymentsMethodsId=${ByPaymentsMethodsId}&Type=${ByType}`);
    },



    GetInvoiceNumber(Type) {
        return axios.get(`api/admin/Financial/Invoice/GetInvoiceNumber?Type=${Type}`);
    },

    GetInvoiceIn(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Financial/InvoiceIn/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },
   
    AddInvoiceIn(bodyObject) {
        return axios.post(`api/admin/Financial/InvoiceIn/Add`, bodyObject);
    },

    EditInvoiceIn(bodyObject) {
        return axios.post(`api/admin/Financial/InvoiceIn/Edit`, bodyObject);
    },

    SaveInvoiceIn(bodyObject) {
        return axios.post(`api/admin/Financial/InvoiceIn/Save`, bodyObject);
    },

    ConfirmInvoiceIn(Id) {
        return axios.post(`api/admin/Financial/${Id}/InvoiceIn/Confirm`);
    },

    CancelInvoiceIn(Id) {
        return axios.post(`api/admin/Financial/${Id}/InvoiceIn/Cancel`);
    },

    DeleteInvoiceIn(Id) {
        return axios.post(`api/admin/Financial/${Id}/InvoiceIn/Delete`);
    },



    //InvoiceOut
    AddInvoiceOut(bodyObject) {
        return axios.post(`api/admin/Financial/InvoiceOut/Add`, bodyObject);
    },

    SaveInvoiceOut(bodyObject) {
        return axios.post(`api/admin/Financial/InvoiceOut/Save`, bodyObject);
    },

    GetInvoiceOut(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Financial/InvoiceOut/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },




    //Item
    GetInvoiceProducts(Id) {
        return axios.get(`api/admin/Financial/Invoice/Item/Get?Id=${Id}`);
    },

    AddItemToInvoice(bodyObject) {
        return axios.post(`api/admin/Financial/Invoice/Item/Add`, bodyObject);
    },

    DeleteInvoiceItem(Id) {
        return axios.post(`api/admin/Financial/${Id}/Invoice/Item/Delete`);
    },


    //Installments
    GetInvoiceInstallments(Id) {
        return axios.get(`api/admin/Financial/Invoice/Installments/Get?Id=${Id}`);
    },

    AddInstallment(bodyObject) {
        return axios.post(`api/admin/Financial/Invoice/Installments/Add`, bodyObject);
    },

    DeleteInstallment(Id) {
        return axios.post(`api/admin/Financial/${Id}/Invoice/Installments/Delete`);
    },



    //// ********************************| End Of Financial |********************************






    // ********************************| Start Dictionaries |******************************

    // Categories
    GetCategories(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/Categories/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllCategories() {
        return axios.get(`api/admin/Dictionaries/Categories/GetAll`);
    },

    AddCategories(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Categories/Add`, bodyObject);
    },

    EditCategories(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Categories/Edit`, bodyObject);
    },

    DeleteCategories(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Categories/Delete`);
    },

    ChangeStatusCategories(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Categories/ChangeStatus`);
    },




    // Branches
    GetBranches(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/Branches/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllBranches() {
        return axios.get(`api/admin/Dictionaries/Branches/GetAll`);
    },

    AddBranches(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Branches/Add`, bodyObject);
    },

    EditBranches(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Branches/Edit`, bodyObject);
    },

    DeleteBranches(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Branches/Delete`);
    },

    ChangeStatusBranches(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Branches/ChangeStatus`);
    },




    // Customers
    GetCustomers(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/Customers/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllCustomers() {
        return axios.get(`api/admin/Dictionaries/Customers/GetAll`);
    },

    AddCustomers(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Customers/Add`, bodyObject);
    },

    EditCustomers(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Customers/Edit`, bodyObject);
    },

    DeleteCustomers(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Customers/Delete`);
    },

    ChangeStatusCustomers(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Customers/ChangeStatus`);
    },


    //Suppliers
    GetSuppliers(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/Suppliers/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllSuppliers() {
        return axios.get(`api/admin/Dictionaries/Suppliers/GetAll`);
    },

    AddSuppliers(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Suppliers/Add`, bodyObject);
    },

    EditSuppliers(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Suppliers/Edit`, bodyObject);
    },

    DeleteSuppliers(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Suppliers/Delete`);
    },

    ChangeStatusSuppliers(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Suppliers/ChangeStatus`);
    },



    // Stocking
    GetStocking(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/Stocking/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllStocking() {
        return axios.get(`api/admin/Dictionaries/Stocking/GetAll`);
    },

    AddStocking(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Stocking/Add`, bodyObject);
    },

    EditStocking(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Stocking/Edit`, bodyObject);
    },

    DeleteStocking(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Stocking/Delete`);
    },

    ChangeStatusStocking(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Stocking/ChangeStatus`);
    },



    // PaymentsMethods
    GetPaymentsMethods(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/PaymentsMethods/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllPaymentsMethods() {
        return axios.get(`api/admin/Dictionaries/PaymentsMethods/GetAll`);
    },

    AddPaymentsMethods(bodyObject) {
        return axios.post(`api/admin/Dictionaries/PaymentsMethods/Add`, bodyObject);
    },

    EditPaymentsMethods(bodyObject) {
        return axios.post(`api/admin/Dictionaries/PaymentsMethods/Edit`, bodyObject);
    },

    DeletePaymentsMethods(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/PaymentsMethods/Delete`);
    },

    ChangeStatusPaymentsMethods(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/PaymentsMethods/ChangeStatus`);
    },











    //Dashboard
    GetDashboardInfo() {
        return axios.get(`api/admin/Dictionaries/Dashboard/Get`);
    },



    // ********************************| End Dictionaries |********************************










    // ********************************| Users |********************************
    GetUsers(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Users/Get?pageNo=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetUsersTransactions(pageNoT, pageSizeT, Id) {
        return axios.get(`api/admin/Users/GetTransactions?pageNo=${pageNoT}&pagesize=${pageSizeT}&Id=${Id}`);
    },

    GetAllUsers() {
        return axios.get(`api/admin/Users/GetAll`);
    },

    AddUsers(bodyObject) {
        return axios.post('api/admin/Users/Add', bodyObject);
    },

    EditUsers(bodyObject) {
        return axios.post('api/admin/Users/Edit', bodyObject);
    },

    ResetPasswordUsers(Id) {
        return axios.post(`api/admin/Users/${Id}/ResetPassword`);
    },

    ChangeStatusUsers(Id) {
        return axios.post(`api/admin/Users/${Id}/ChangeStatus`);
    },

    DeleteUsers(Id) {
        return axios.post(`api/admin/Users/${Id}/Delete`);
    },


    //USerProfile 
    ChangeProfilePicture(bodyObject) {
        return axios.post('api/admin/Users/Profile/ChangePicture', bodyObject);
    },

    ChangeProfileInfo(bodyObject) {
        return axios.post('api/admin/Users/Profile/ChangeInfo', bodyObject);
    },

    ChangeProfilePassword(bodyObject) {
        return axios.post('api/admin/Users/Profile/ChangePassword', bodyObject);
    },



    // ********************************| End Of Users |********************************



}